import React from "react"
import { graphql, useStaticQuery } from "gatsby"
//import { useLocalization } from "gatsby-theme-i18n"
import { useI18next } from "gatsby-plugin-react-i18next"
import Event from "models/event"

const useCollectionEvents = ({ category, type, eventsToShow, limit } = {}) => {
  //const { locale } = useLocalization()
  const { language: locale } = useI18next()

  const data = useStaticQuery(graphql`
    query AllCollectionEventsQuery {
      events: allCollectionEvents(sort: { startDate: ASC }) {
        nodes {
          id
          locale
          title
          startDate
          startTime
          endDate
          endTime
          url
          category {
            title
            slug
          }
          type: eventType {
            title
            slug
          }
          teaserExcerpt
          teaserImage {
            alt
            localImage {
              childImageSharp {
                gatsbyImageData(width: 90, height: 90)
              }
            }
          }
        }
      }
    }
  `)

  /**
   * Get all events in the current locale
   * and apply filters if needed
   */
  return React.useMemo(() => {
    let events = data.events.nodes.filter(n => n.locale === locale)

    if (category) {
      events = events.filter(
        item => item.category && item.category.some(c => c.slug === type)
      )
    }

    if (type) {
      events = events.filter(
        item => item.type && item.type.some(c => c.slug === type)
      )
    }

    events = events.map(event => new Event(event))

    // sort by date and time
    events = events.sort((a, b) => a.getFullStartDate() - b.getFullStartDate())

    if (eventsToShow === "future") {
      events = events.filter(event =>
        ["future", "pending"].includes(event.getTimeStatus())
      )
    }

    if (eventsToShow === "past") {
      events = events
        .filter(event => event.getTimeStatus() === "past")
        // and sort from recent to oldest
        .reverse()
    }
    events.sort((a, b) => b.getFullDate() - a.getFullDate())

    if (limit) {
      events = events.slice(0, limit)
    }

    return events
  }, [data, locale, category, eventsToShow, type])
}

export default useCollectionEvents
